import CreateTypeDialog from './CreateTypeDialog';

export default CreateTypeDialog;
